import { api } from "../../api/axios";

const controller = "Status";
export async function GetStatusesAsync() {
  return await api.get(`${controller}/GetStatuses`);
}
